import React from "react";
import { Alert, AlertIcon, AlertDescription } from "@chakra-ui/react";

const ErrorAlert = ({ message }) => {
  return (
    <Alert status="error">
      <AlertIcon />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
};

export default ErrorAlert;
